import { Extension } from '@tiptap/core';

// ═══════════════════════════════════════════════════════════════
// FontSize — velikost písma na úrovni runu.
//
// TipTap TextStyle sám o velikosti písma neví; tento doplněk přidává
// atribut `fontSize`, který se renderuje jako inline `font-size` na
// <span> (přes textStyle mark). Export ho pak čte z `el.style.fontSize`.
//
// Použití: editor.chain().focus().setFontSize('14pt').run()
//          editor.chain().focus().unsetFontSize().run()
// ═══════════════════════════════════════════════════════════════

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    fontSize: {
      setFontSize: (size: string) => ReturnType;
      unsetFontSize: () => ReturnType;
    };
  }
}

export const FontSize = Extension.create({
  name: 'fontSize',

  addOptions() {
    return { types: ['textStyle'] };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (element) => element.style.fontSize || null,
            renderHTML: (attributes) => {
              if (!attributes.fontSize) return {};
              return { style: `font-size: ${attributes.fontSize}` };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setFontSize:
        (size: string) =>
        ({ chain }) =>
          chain().setMark('textStyle', { fontSize: size }).run(),
      unsetFontSize:
        () =>
        ({ chain }) =>
          chain().setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run(),
    };
  },
});
